import {
  LIGHTBOX_CLOSE,
  LIGHTBOX_CLOSE_ALL,
  LIGHTBOX_OPEN,
  LIGHTBOX_UPDATE,
  LightboxDocument,
} from 'store/actions/lightboxActions';

interface State {
  docs: LightboxDocument[];
}

const INITIAL_STATE: State = {
  docs: [],
};

const lightboxReducer = (state: State = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LIGHTBOX_OPEN:
      return {
        ...state,
        docs: [...state.docs, payload],
      };

    case LIGHTBOX_UPDATE:
      return {
        ...state,
        docs: state.docs.map((doc) => (doc.id === payload.id ? { ...doc, ...payload } : doc)),
      };

    case LIGHTBOX_CLOSE:
      return {
        ...state,
        docs: state.docs.filter((doc) => doc.id !== payload.id),
      };

    case LIGHTBOX_CLOSE_ALL:
      return {
        ...state,
        docs: [],
      };

    default:
      return state;
  }
};

export default lightboxReducer;
